import React from 'react';
import Heart from "../../images/SZ_hjarta.png";
import RedPin from "../../images/pin.png";

const Legend = () => {
  return (
    <div className="legend">
      <div className="row-legend">
        <img src={Heart} alt="Heart pin" />
        <p>Volontärer</p>
      </div>
      <div className="row-legend">
        <img src={RedPin} alt="Red pin" />
        <p>Medborgarförslag</p>
      </div>
      <div className="row-legend">
        <div className="greendot"></div>
        <p>Handlingsplan</p>
      </div>
  </div>
  );
};

export default Legend;